
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/computer-vision-services",
      function () {
        return require("private-next-pages/computer-vision-services.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/computer-vision-services"])
      });
    }
  